export default function HeroSection() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0d5f9305e86bcad2f8d2c50d36b2fd9c.jpg"
          alt="Quality rental homes"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Looking to Rent a House or an Apartment Unit?
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Find Your Perfect Home with TREX RE LLC
        </p>
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Quality houses, duplexes, and apartments available for rent in El Paso. Join our waitlist today and be the first to know about new rental opportunities.
        </p>
        <a
          href="#waitlist"
          className="inline-block bg-teal-500 text-white px-10 py-4 rounded-lg text-lg font-semibold hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
        >
          Join Our Waitlist
        </a>
      </div>
    </section>
  );
}
